export default __webpack_public_path__ + "static/media/48_mobile.4642ce06.jpg";